// rxjs-extension/reactives/client/local-storage.ts
import { BehaviorSubject } from "rxjs";
function getLocalStorageValue(lsKey, value) {
  const lsValue = localStorage.getItem(lsKey);
  if (lsValue) {
    try {
      return JSON.parse(lsValue);
    } catch (e) {
      return lsValue;
    }
  }
  localStorage.setItem(lsKey, JSON.stringify(value));
  return value;
}
var LocalStorageReactive = class extends BehaviorSubject {
  constructor(localStorageKey, defaultValue) {
    super(getLocalStorageValue(localStorageKey, defaultValue));
    this.lsKey = "";
    this.lsKey = localStorageKey;
    this.defaultValue = defaultValue;
  }
  next(value) {
    value = value !== null && value !== void 0 ? value : this.defaultValue;
    if (JSON.stringify(value) === localStorage.getItem(this.lsKey))
      return;
    localStorage.setItem(this.lsKey, JSON.stringify(value));
    super.next(value);
  }
  delete() {
    localStorage.removeItem(this.lsKey);
  }
};
export {
  LocalStorageReactive
};
